module.exports = __webpack_public_path__ + "img/panelView_3_3_old.8211cea2.png";